<ng-container *transloco="let t">
  @let shippingCostResponse = this.shippingCostResponse();

  @if (hasMinimumPurchaseErrorAmount(shippingCostResponse)) {
    <!-- Minimum purchase error -->
    <pxw-shipping-not-allowed
      [isFormSubmitted]="isFormSubmitted()"
      [message]="
        t('shippingCostResponse.minimumPurchaseError', {
          minimumPurchase: shippingCostResponse.minimumPurchaseErrorAmount | currencyFormat,
        })
      "
    />
  } @else if (hasFreeShippingGrantedAmount(shippingCostResponse)) {
    <!-- Free delivery granted -->
    <div style="max-width: 100%">
      <pxw-alert type="success" size="sm" display="inline-block" style="width: 100%">
        <pxw-icon icon="price-discount" #customIcon />
        {{ t('shippingCostResponse.freeShippingGranted') }}
      </pxw-alert>
    </div>
  } @else if (hasShippingEstimateBlockOrder(shippingCostResponse)) {
    <!-- Rapiboy configurado para bloquear pedidos -->
    <pxw-shipping-not-allowed
      [isFormSubmitted]="isFormSubmitted()"
      [message]="
        checkoutData()?.shippingOptionTakeAway?.active
          ? t('shippingCostResponse.rapiboyBlockedWithPickupAlert')
          : t('shippingCostResponse.rapiboyBlockedAlert')
      "
    />
  } @else if (hasShippingEstimateError(shippingCostResponse)) {
    <!-- Shipping estimate error (non-blocking) -->
    @let errorKey = getShippingErrorTranslationKey(shippingCostResponse.shippingEstimate.error);
    <pxw-shipping-continue-with-confirmation
      [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
      [isFormSubmitted]="isFormSubmitted()"
      [message]="errorKey ? t(errorKey) : shippingCostResponse.shippingEstimate.error"
    />
  } @else if (hasOutOfDeliveryZone(shippingCostResponse)) {
    <!-- Out of delivery zone -->
    @if (shippingCostResponse.shippingOption.outOfDeliveryZoneShippingAllowed) {
      <!-- Allowed with confirmation -->
      <pxw-shipping-continue-with-confirmation
        [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
        [isFormSubmitted]="isFormSubmitted()"
        [message]="t('shippingCostResponse.outOfDeliveryZoneAlert')"
      />
    } @else {
      <!-- Shipping disabled -->
      <pxw-shipping-not-allowed
        [isFormSubmitted]="isFormSubmitted()"
        [message]="t('shippingCostResponse.outOfDeliveryZoneForbiddenAlert')"
      />
    }
  } @else if (hasDeliveryCost(shippingCostResponse)) {
    <!-- Display delivery cost -->
    <pxw-alert type="warning" size="sm" display="inline-block">
      <pxw-icon icon="shipping" #customIcon />
      {{ t('shippingCostResponse.costLabel') }}:
      <strong>{{ shippingCostResponse.deliveryCost | currencyFormat }}</strong>

      @if (shippingCostResponse.shippingOption.deliveryType === deliveryTypes.FIXED) {
        <ng-template #alertDetails>
          <span class="shipping-cost-helper"> *{{ t('shippingCostResponse.costHelper') }} </span>
        </ng-template>
      }
    </pxw-alert>

    @if (hasMinimumPurchaseForFreeShipping(shippingCostResponse)) {
      <!-- Can unlock free shipping -->
      <pxw-alert
        type="info"
        appareance="bare"
        size="xs"
        display="inline-block"
        style="margin-top: 0.3em"
      >
        <pxw-icon icon="price-discount" #customIcon />
        *
        {{
          t('shippingCostResponse.minimumPurchaseForFreeShipping', {
            minimumPurchaseForFreeShipping:
              shippingCostResponse.minimumPurchaseForFreeShipping | currencyFormat,
          })
        }}
      </pxw-alert>
    }
  } @else if (hasDeliveryCostToBeDefined(shippingCostResponse)) {
    <!-- Delivery cost to be defined -->
    <pxw-shipping-continue-with-confirmation
      [(outOfDeliveryZoneConfirmed)]="outOfDeliveryZoneConfirmed"
      [isFormSubmitted]="isFormSubmitted()"
      [message]="t('shippingCostResponse.toBeDefined')"
    />
  }
</ng-container>
